<template>
	<HeroComponent>

		<template v-slot:hero-image>
			<div class="background-banner-profile-settings-page { w-100 h-100 d-flex flex-row justify-center"
				style="position: relative;">
				<settings-banner-item1 class="h-100 profile-settings-banner__item1"></settings-banner-item1>
			</div>
		</template>


		<template v-slot:hero-title>
			Settings
		</template>


		<template v-slot:hero-subtitle>
			Verify phone number and update PayPal withdraw email.
		</template>

	</HeroComponent>
</template>



<script setup>

import SettingsBannerItem1 from '@/icons/SettingsBannerItem1.vue';
import HeroComponent from '@/components/Common/Hero-Component.vue';

</script>